/**
 * 门店管理 · 标签管理（PRD §6；接口 URL 待对接）
 */
import { tagEditDialog } from './_dialogs'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/base/AdminBaseShopTagQueryController/page'
      },
      add: {
        label: '新建标签',
        api: '/cabinet/admin/base/AdminBaseShopTagCommandController/save',
        dialog: tagEditDialog(false),
        successMessage: '保存成功'
      },
      edit: {
        label: '修改',
        api: '/cabinet/admin/base/AdminBaseShopTagCommandController/update',
        dialog: tagEditDialog(true),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/cabinet/admin/base/AdminBaseShopTagCommandController/delete',
        message: '确认删除该标签？已绑定门店时删除将解除关联。',
        payload: {
          tagCode: '${data.row.tagCode}'
        }
      }
    },
    search: {
      labelWidth: 100,
      items: [{ type: 'input', prop: 'tagName', label: '标签名称', span: 8 }]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 140,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      columns: [
        { label: '标签名称', prop: 'tagName', minWidth: 160 },
        { label: '绑定门店数', prop: 'shopBindCount', minWidth: 120 },
        {
          label: '创建时间',
          prop: 'gmtCreate',
          minWidth: 165,
          formatter: (row: any) => (row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
